export const stringsKey = "MessageSenderConfiguration";
export const englishStrings = {
	alphanumericSenderIdLabel: "Alphanumeric sender ID",
	phoneNumberLabel: "Phone Number",
	whatsappEnabledPhoneNumberLabel: "WhatsApp Enabled Phone Number",
	whatsappEnabledPhoneNumberError:
		"WhatsApp enabled phone number is not configured for your country",
	selectPhoneNumberLabel: "Select Phone Number",
	fromNumberRequiredMessage: "The From number field is required.",
	senderIdRegistrationRequiredMessage:
		"Alphanumeric sender ID Registration is mandatory.",
	noPhoneNumberAvailableMessage:
		"You need to purchase a phone number, as its not available for selected country.",
	countryDetailErrorMessage: "Error loading country detail, Please try again",
	phoneNumberListErrorMessage:
		"Error loading phone number list, Please try again",
	alphaNumericSenderIdInfoTooltip:
		"Sender Id must start with a letter. Special characters(dash(-), underscore(_), space( )) and Maximum 11 characters allowed.",
	africasTalkingInfoMessage:
		"Please ensure short code or alphanumeric id is configured, in",
	vodafoneSenderIdLabel: "Vodafone Sender ID",
	vodafoneSenderIdTooltip: "E 164 Format Phone Number",
	formatError: "Incorrect number format",
};
